/**
  Autogenerated file. Do not edit manually.
  @openapi https://search-bff.envdevel.com/v3/api-docs
*/

import type {
  AgentResponse
} from '../../models';

import { customInstance } from '../../custom-instance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * Returns an agent based on a given id
 */
export const getAgent2 = (
    agentId: string,
 options?: SecondParameter<typeof customInstance<AgentResponse>>,) => {
      return customInstance<AgentResponse>(
      {url: `/api/v1/agent/${agentId}`, method: 'GET'
    },
      options);
    }
  export type GetAgent2Result = NonNullable<Awaited<ReturnType<typeof getAgent2>>>
